import axios from 'axios';
import authToken from 'js/library/utils/API/authToken';
import cfac22 from '../cfac22';

export function getVoucherTemplate(uId, voucherId) {
  return new Promise((resolve, reject) => {
    authToken(uId)
      .then((token) => {
        axios
          .get(`${cfac22('API_HOST_V2')}/voucherTemplate/${voucherId}`, {
            headers: { authorization: `Bearer ${token}`, 'Full-Url': window.location.href },
          })
          .then((result) => {
            //console.log("RESULT_VOUCHER: ", result);
            resolve(result.data.result);
          })
          .catch((error) => {
            //console.log("ERROR_VOUCHER: ", error);
            return reject(error);
          });
      })
      .catch((error) => {
        //console.log("ERROR_TOKEN:", error);
        reject(error);
      });
  });
}
